import React, { useEffect, useState } from 'react';
import { LandingBootLoader } from './LandingPage';
import './tivigoAuthFrame.css';

const AUTH_LOADER_VISIBLE_MS = 450;
const AUTH_LOADER_FADE_MS = 340;

function WindowsPreview() {
  return (
    <div className="tv-auth-windows-preview">
      <div className="tv-auth-windows-preview-media">
        <video
          src="/assets/images/product/windows-dashboard-tour-v6.mp4"
          poster="/assets/images/product/windows-home.jpg"
          width="1280"
          height="764"
          aria-label="Tivigo Windows uygulaması tanıtım turu"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
        />
      </div>
    </div>
  );
}

function WindowsHeroCopy() {
  return (
    <div className="tv-auth-windows-hero-copy">
      <h2>
        Türkiye’de bir ilk olan <strong>Tivigo Windows</strong> Uygulaması yayınlandı!
      </h2>
      <div>Hesabınızı bilgisayardan yönetmek ve içerikleri izlemek için hemen indirin.</div>
    </div>
  );
}

function TivigoAuthFrame({ children, view = 'login', pageKey = view }) {
  const [loaderLeaving, setLoaderLeaving] = useState(false);
  const [loaderMounted, setLoaderMounted] = useState(true);

  useEffect(() => {
    setLoaderLeaving(false);
    setLoaderMounted(true);

    const leaveTimer = window.setTimeout(() => {
      setLoaderLeaving(true);
    }, AUTH_LOADER_VISIBLE_MS);
    const removeTimer = window.setTimeout(() => {
      setLoaderMounted(false);
    }, AUTH_LOADER_VISIBLE_MS + AUTH_LOADER_FADE_MS);

    return () => {
      window.clearTimeout(leaveTimer);
      window.clearTimeout(removeTimer);
    };
  }, [pageKey, view]);

  return (
    <>
      {loaderMounted && <LandingBootLoader leaving={loaderLeaving} />}
      <div className={`tv-auth-shell is-${view}`} aria-busy={loaderMounted}>
      <aside className="tv-auth-brand-panel">
        <div className="tv-auth-brand-top">
          <img src="/assets/images/tivigo-wordmark.png" alt="Tivigo" />
        </div>

        <WindowsHeroCopy />
        <WindowsPreview />
      </aside>

      <main className="tv-auth-form-surface">
        <div className="tv-auth-mobile-brand">
          <img src="/assets/images/tivigo-wordmark.png" alt="Tivigo" />
          <span>HESAP MERKEZİ</span>
        </div>
        <div className="tv-auth-content">{children}</div>
      </main>
      </div>
    </>
  );
}

export default TivigoAuthFrame;
